import React, { useState } from 'react';
import {
	Box,
	Paper,
	Typography,
	Tabs,
	Tab,
	TextField,
	Button,
	Grid,
	Link,
	InputBase,
	ButtonBase,
} from '@mui/material';
import { helperText } from '../assets/theme/Theme';
import TextInput from '../components/TextInput';
import { useNavigate } from 'react-router-dom';
import {
	getRememberMe,
	setElderHomeId,
	setElderHomeName,
	setExpireTime,
	setRememberMe,
	setUserName,
} from '../Utils/AuthUtil';
import {
	createNewUserAccount,
	fetchCareHome,
	fetchUser,
	loginUser,
} from '../services/UserService';
import Logo from '../assets/images/Logo.png';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import { getEnabledUserFeatures } from '../context/MainProvider';
import { USER_ROLES, WEB_ACCOUNT } from '../Utils/Enums';
import { toast } from 'react-toastify';
import { border, dark, teal } from '../assets/theme/Colors';

const initialErrorState = {
	status: false,
	msg: '',
};

export default function AuthScreen() {
	const [tab, setTab] = useState(0);

	const handleTabChange = (_, newValue) => {
		setTab(newValue);
	};

	const navigator = useNavigate();
	const { storeEnabledUserFeatures } = getEnabledUserFeatures();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(0);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [loginStatus, setLoginStatus] = useState(initialErrorState);
	const [show, setShow] = useState(false);
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [careHome, setCareHome] = useState('');
	const [crEmail, setCrEmail] = useState('');
	const [crPassword, setCrPassword] = useState('');
	const [reEnterPassword, setReEnterPassword] = useState('');
	const [firstNameError, setFirstNameError] = useState(initialErrorState);
	const [lastNameError, setLastNameError] = useState(initialErrorState);
	const [careHomeError, setCareHomeError] = useState(initialErrorState);
	const [crEmailError, setCrEmailError] = useState(initialErrorState);
	const [crPasswordError, setCrPasswordError] = useState(initialErrorState);
	const [passwordReEnterError, setPasswordReEnterError] =
		useState(initialErrorState);
	const [crShow, setCrShow] = useState(false);
	const [showReEntered, setShowReEntered] = useState(false);

	function onChangeEmail(value) {
		setEmailError(initialErrorState);
		setEmail(value);
	}

	function onChangePassword(event) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	async function logIn(params) {
		let error = false;
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}

		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}

		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}

		if (error) {
			return;
		} else {
			setLoginStatus(initialErrorState);

			const response = await loginUser(email, password);

			if (
				response.status === 200 &&
				(response.role === USER_ROLES.admin ||
					response.role === USER_ROLES.staff)
			) {
				await fetchUserData(
					response.userId,
					response.token,
					response.role,
				);
				setExpireTime('admin');
				navigator('/home');
			} else if (
				response.status === 200 &&
				response.role === USER_ROLES.superAdmin
			) {
				setUserName('Super Admin');
				navigator('/admin');
				setExpireTime();
			} else if (response.status === 400) {
				setLoginStatus({
					status: true,
					msg: 'Email or password is incorrect',
				});
			} else {
				setLoginStatus({
					status: true,
					msg: 'Something went wrong, please try again.',
				});
			}
		}
	}

	const onChangeRememberMe = () => {
		const val = parseInt(getRememberMe());
		if (val === 0 || val === 2) {
			setRemember(1);
			setRememberMe(1);
		}
		if (val === 1) {
			setRemember(0);
			setRememberMe(0);
		}
	};

	async function fetchUserData(id, token, role) {
		const route = role === USER_ROLES.staff ? 'staff' : 'admin';
		const data = await fetchUser(id, token, route);
		if (data.content) {
			storeEnabledUserFeatures(data.content.featuresTypes);
			setUserName(data.content.username);
			setElderHomeId(data.content.elderHomeId);
			const homeRes = await fetchCareHome(
				data.content.elderHomeId,
				token,
			);
			setElderHomeName(homeRes.content?.name);
		}
	}

	function onChangeFirstName(event) {
		setFirstNameError(initialErrorState);
		setFirstName(event.target.value);
	}

	function onChangeLastName(event) {
		setLastNameError(initialErrorState);
		setLastName(event.target.value);
	}

	function onChangeCareHome(event) {
		setCareHomeError(initialErrorState);
		setCareHome(event.target.value);
	}

	function onChangeCrEmail(event) {
		setEmailError(initialErrorState);
		setCrEmail(event.target.value);
	}

	function onChangeCrPassword(event) {
		setPasswordError(initialErrorState);
		setCrPassword(event.target.value);
	}

	function onChangeReEnterPassword(event) {
		setPasswordReEnterError(initialErrorState);
		setReEnterPassword(event.target.value);
	}

	function onValidateInputs() {
		let error = false;

		if (!firstName || firstName === '') {
			setFirstNameError({ status: true, msg: 'First Name is Required.' });
			error = true;
		}
		if (!lastName || lastName === '') {
			setLastNameError({ status: true, msg: 'Last Name is Required.' });
			error = true;
		}
		if (!careHome || careHome === '') {
			setCareHomeError({ status: true, msg: 'Care Home is Required.' });
			error = true;
		}
		if (!crEmail || crEmail === '') {
			setCrEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}
		if (crEmail !== '' && crEmail.indexOf('@') === -1) {
			setCrEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}
		if (!crPassword || crPassword === '') {
			setCrPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}
		// if (!reEnterPassword || reEnterPassword === '') {
		// 	setPasswordReEnterError({
		// 		status: true,
		// 		msg: 'Re-enter the password.',
		// 	});
		// 	error = true;
		// }
		if (crPassword.length < 8) {
			setCrPasswordError({
				status: true,
				msg: 'Password should be at least 8 characters long.',
			});
			error = true;
		}
		// if (crPassword.length >= 8 && crPassword !== reEnterPassword) {
		// 	setCrPasswordError({
		// 		status: true,
		// 		msg: 'Password is not matched.',
		// 	});
		// 	error = true;
		// }

		return error;
	}

	async function onClickCreateAccount() {
		const error = onValidateInputs();

		if (error) {
			return;
		} else {
			const body = {
				firstname: firstName,
				lastname: lastName,
				username: `${firstName} ${lastName}`,
				email: crEmail,
				password: crPassword,
				accountType: WEB_ACCOUNT,
				careHome: careHome,
			};
			const response = await createNewUserAccount(body);
			if (response.message === 'Success') {
				setTab(0);
				toast.success('Account created successfully.');
			} else {
				toast.error(response.message);
			}
		}
	}

	return (
		<Box
			sx={{
				background: 'linear-gradient(135deg, #0f2e2e 0%, #1a4848 100%)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '100vh',
				p: 3,
			}}>
			<Paper
				elevation={0}
				sx={{
					width: 380,
					p: 4.5,
					borderRadius: '16px',
					boxShadow: '0 24px 48px rgba(0,0,0,0.3)',
				}}>
				{/* Logo */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '10px',
						mb: '6px',
					}}>
					<img
						src={Logo}
						alt="SenzCare.AI"
						style={{
							height: 36,
							display: 'block',
						}}
					/>
				</Box>

				<Typography
					sx={{
						fontSize: '12px',
						color: '#6b8888',
						mb: 3,
						pl: '46px',
					}}>
					Person-centred care intelligence platform
				</Typography>

				{/* Tabs */}
				<Tabs
					value={tab}
					onChange={handleTabChange}
					variant="fullWidth"
					sx={{
						minHeight: 'unset',
						mb: 3,
						border: '1px solid #d8e8e8',
						borderRadius: '8px',
						overflow: 'hidden',
						'& .MuiTabs-indicator': {
							display: 'none',
						},
						'& .MuiTab-root': {
							minHeight: 'unset',
							py: '9px',
							fontSize: '13px',
							fontWeight: 500,
							color: '#6b8888',
							textTransform: 'none',
						},
						'& .Mui-selected': {
							backgroundColor: dark,
							color: '#fff !important',
						},
					}}>
					<Tab label="Sign In" />
					<Tab label="Create Account" />
				</Tabs>

				{/* SIGN IN */}
				{tab === 0 && (
					<>
						<Box sx={{ mb: 1.5 }}>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: 500,
									color: '#6b8888',
									mb: '5px',
								}}>
								Email
							</Typography>

							<TextField
								fullWidth
								error={emailError.status}
								onChange={e => onChangeEmail(e.target.value)}
								onKeyPress={e => e.code === 'Enter' && logIn()}
								size="small"
								variant="outlined"
								placeholder="Enter email"
								sx={{
									'& .MuiOutlinedInput-root': {
										fontSize: '13px',
										borderRadius: '8px',
										'& fieldset': {
											borderColor: border,
										},
									},
								}}
							/>
							<Typography style={helperText}>
								{emailError.msg}
							</Typography>
						</Box>

						<Box>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: 500,
									color: '#6b8888',
									mb: '5px',
								}}>
								Password
							</Typography>
						</Box>
						<Grid
							container
							alignItems="center"
							justifyContent="space-between"
							sx={{
								border: passwordError.status
									? '1px solid #d32f2f'
									: '1px solid #d8e8e8',
								borderRadius: '8px',
								px: '12px',
								height: '35px', // same as MUI small TextField
								transition: 'all 0.2s ease',
								backgroundColor: '#fff',

								'&:hover': {
									borderColor: passwordError.status
										? '#d32f2f'
										: '#000000',
								},

								'&:focus-within': {
									borderColor: passwordError.status
										? '#d32f2f'
										: dark,
									boxShadow: passwordError.status
										? '0 0 0 2px rgba(211,47,47,0.1)'
										: '0 0 0 2px rgba(15,46,46,0.08)',
								},
							}}>
							<InputBase
								type={show ? 'text' : 'password'}
								onChange={onChangePassword}
								onKeyPress={e => e.code === 'Enter' && logIn()}
								sx={{
									flex: 1,
									fontSize: '13px',
									color: '#777E90',

									'& input': {
										height: '35px',
										padding: 0,
										boxSizing: 'border-box',
									},

									'& input::placeholder': {
										color: '#9aa5b1',
										opacity: 1,
										fontSize: '13px',
									},
								}}
								placeholder="Enter password"
							/>

							<ButtonBase
								onClick={() => setShow(!show)}
								sx={{
									ml: 1,
									height: '100%',
									display: 'flex',
									alignItems: 'center',
									color: '#6b8888',
								}}>
								{show ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{passwordError.msg}
						</Typography>
						{loginStatus.status && (
							<Grid container justifyContent={'center'}>
								<Typography style={helperText}>
									{loginStatus.msg}
								</Typography>
							</Grid>
						)}
						<Button
							fullWidth
							onClick={logIn}
							sx={{
								py: '11px',
								mb: '10px',
								backgroundColor: teal,
								color: dark,
								fontSize: '14px',
								fontWeight: 700,
								borderRadius: '8px',
								textTransform: 'none',
								fontFamily: "'DM Sans', sans-serif",
								'&:hover': {
									backgroundColor: '#00b3a4',
								},
								mt: '10px',
							}}>
							Sign In to SenzCare.AI
						</Button>

						<Typography
							align="center"
							sx={{
								fontSize: '12px',
								color: '#6b8888',
							}}>
							Forgot password?{' '}
							<Link
								href="#"
								underline="hover"
								sx={{
									color: teal,
									fontSize: '12px',
								}}>
								Reset
							</Link>
						</Typography>
					</>
				)}

				{/* SIGN UP */}
				{tab === 1 && (
					<>
						<Grid container spacing={1.25} sx={{ mb: 1.5 }}>
							<Grid item xs={6}>
								<Typography
									sx={{
										fontSize: '12px',
										fontWeight: 500,
										color: '#6b8888',
										mb: '5px',
									}}>
									First Name
								</Typography>

								<TextField
									fullWidth
									onChange={onChangeFirstName}
									placeholder="First name"
									size="small"
									sx={{
										'& .MuiOutlinedInput-root': {
											fontSize: '13px',
											borderRadius: '8px',
											'& fieldset': {
												borderColor: border,
											},
										},
									}}
									error={firstNameError.status}
								/>
								<Typography style={helperText}>
									{firstNameError.msg}
								</Typography>
							</Grid>

							<Grid item xs={6}>
								<Typography
									sx={{
										fontSize: '12px',
										fontWeight: 500,
										color: '#6b8888',
										mb: '5px',
									}}>
									Last Name
								</Typography>

								<TextField
									fullWidth
									onChange={onChangeLastName}
									placeholder="Last name"
									size="small"
									sx={{
										'& .MuiOutlinedInput-root': {
											fontSize: '13px',
											borderRadius: '8px',
											'& fieldset': {
												borderColor: border,
											},
										},
									}}
									error={lastNameError.status}
								/>
								<Typography style={helperText}>
									{lastNameError.msg}
								</Typography>
							</Grid>
						</Grid>

						<Box sx={{ mb: 1.5 }}>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: 500,
									color: '#6b8888',
									mb: '5px',
								}}>
								Care Home / Organization
							</Typography>

							<TextField
								fullWidth
								onChange={onChangeCareHome}
								placeholder="SenzCare Home"
								size="small"
								sx={{
									'& .MuiOutlinedInput-root': {
										fontSize: '13px',
										borderRadius: '8px',
										'& fieldset': {
											borderColor: border,
										},
									},
								}}
								error={careHomeError.status}
							/>
							<Typography style={helperText}>
								{careHomeError.msg}
							</Typography>
						</Box>

						<Box sx={{ mb: 1.5 }}>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: 500,
									color: '#6b8888',
									mb: '5px',
								}}>
								Work Email
							</Typography>

							<TextField
								fullWidth
								placeholder="admin@senzcare.com"
								onChange={onChangeCrEmail}
								size="small"
								sx={{
									'& .MuiOutlinedInput-root': {
										fontSize: '13px',
										borderRadius: '8px',
										'& fieldset': {
											borderColor: border,
										},
									},
								}}
								error={crEmailError.status}
							/>
							<Typography style={helperText}>
								{crEmailError.msg}
							</Typography>
						</Box>

						<Box sx={{ mb: 2 }}>
							<Typography
								sx={{
									fontSize: '12px',
									fontWeight: 500,
									color: '#6b8888',
									mb: '5px',
								}}>
								Password
							</Typography>

							<Grid
								container
								alignItems="center"
								justifyContent="space-between"
								sx={{
									border: crPasswordError.status
										? '1px solid #d32f2f'
										: '1px solid #d8e8e8',
									borderRadius: '8px',
									px: '12px',
									height: '35px', // same as MUI small TextField
									transition: 'all 0.2s ease',
									backgroundColor: '#fff',

									'&:hover': {
										borderColor: crPasswordError.status
											? '#d32f2f'
											: '#000000',
									},

									'&:focus-within': {
										borderColor: crPasswordError.status
											? '#d32f2f'
											: dark,
										boxShadow: crPasswordError.status
											? '0 0 0 2px rgba(211,47,47,0.1)'
											: '0 0 0 2px rgba(15,46,46,0.08)',
									},
								}}>
								<InputBase
									type={crShow ? 'text' : 'password'}
									onChange={onChangeCrPassword}
									sx={{
										flex: 1,
										fontSize: '13px',
										color: '#777E90',

										'& input': {
											height: '35px',
											padding: 0,
											boxSizing: 'border-box',
										},

										'& input::placeholder': {
											color: '#9aa5b1',
											opacity: 1,
											fontSize: '13px',
										},
									}}
									placeholder="Enter password"
								/>

								<ButtonBase
									onClick={() => setCrShow(!crShow)}
									sx={{
										ml: 1,
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										color: '#6b8888',
									}}>
									{crShow ? (
										<HideEyeIcon
											error={passwordError.status}
										/>
									) : (
										<EyeIcon error={passwordError.status} />
									)}
								</ButtonBase>
							</Grid>
							<Typography style={helperText}>
								{crPasswordError.msg}
							</Typography>
						</Box>

						<Button
							fullWidth
							onClick={onClickCreateAccount}
							sx={{
								py: '11px',
								mb: '10px',
								backgroundColor: teal,
								color: dark,
								fontSize: '14px',
								fontWeight: 700,
								borderRadius: '8px',
								textTransform: 'none',
								fontFamily: "'DM Sans', sans-serif",
								'&:hover': {
									backgroundColor: '#00b3a4',
								},
							}}>
							Create Care Home Admin Account
						</Button>

						<Typography
							align="center"
							sx={{
								mt: '10px',
								fontSize: '11px',
								color: '#6b8888',
							}}>
							You will be set up as Care Home Admin. Invite staff
							after setup.
						</Typography>
					</>
				)}
			</Paper>
		</Box>
	);
}
